import { FC } from 'react';

import styles from './platform-card-item.module.scss';

export interface PlatFormCardItemProps {
    logo?: string;
    title?: string;
    description?: string;
    linkLearnMore?: string;
    showLearnMore?: boolean;
    backgroundColorCard?: string;
}

const PlatFromCardItem: FC<PlatFormCardItemProps> = (props) => {
    const { logo, title, description, linkLearnMore, showLearnMore, backgroundColorCard } = props;

    return (
        <div
            className={styles.container}
            style={{
                backgroundColor: showLearnMore ? '#E7EAED' : '#00D533',
                cursor: showLearnMore ? 'pointer' : 'default',
            }}
        >
            <div
                className={`${styles.logo} ${showLearnMore ? styles['canHover'] : ''}`}
                style={{
                    backgroundColor: showLearnMore ? '#00D533' : '#E7EAED',
                }}
            >
                {/* <img src={logo} alt="" /> */}

                <div
                    style={{
                        WebkitMaskImage: `url(${logo})`,
                        maskImage: `url(${logo})`,
                        backgroundColor: showLearnMore ? '#000000' : '#ffffff',
                    }}
                />
            </div>

            <div className={styles.title} dangerouslySetInnerHTML={{ __html: title || '' }}></div>
            <div className={styles.description} dangerouslySetInnerHTML={{ __html: description || '' }}></div>

            {showLearnMore && (
                <>
                    <a className={styles.tileClick} href={linkLearnMore} target="_blank" />
                    <div className={styles.learnMore}>Learn more</div>
                </>
            )}
        </div>
    );
};

export default PlatFromCardItem;
